export default class ReportClaim {
  constructor(vm) {
    this.vm = vm;
  }

  get(event) {
    let trackingObject = null;
      
    switch (event) {
      case 'question-tree-go-to-create-claim-click':
        trackingObject = {
          'event': 'anmeld skade start',
          'eventCategory': this.vm.product,
          'eventAction': 'step_start',
          'eventLabel': this.vm.damageCodesString,
          'damageCodeDescription': this.vm.damageCodeDescription,
          'timestamp': new Date().getTime(),
          'startTimestamp': new Date(this.vm.startTimestamp).getTime(),
          'finishTimestamp': null,
          'timePassed': this.vm.startTimestamp !== 'false' ? new Date().getTime() - new Date(this.vm.startTimestamp).getTime() : null,
          'totalTime': null
        };
        break;
      case 'create-claim-step-' + this.vm.index:
        trackingObject = {
          'event': 'track-ga-vp',
          'virtualPath': 'opret_skade/' + this.vm.step,
          'virtualTitle': this.vm.title,
          'eventCategory': this.vm.product,
          'eventAction': this.vm.action,
          'eventLabel': this.vm.damageCodeVORefValues,
          'productId': this.vm.productId,
          'damageCode': this.vm.damageCodeVORefIds,
          'damageCodeDescription': this.vm.damageCodeVORefValuesDescription,
          'timestamp': new Date().getTime(),
          'startTimestamp': new Date(this.vm.startTimestamp).getTime(),
          'finishTimestamp': null,
          'timePassed': this.vm.startTimestamp !== 'false' ? new Date().getTime() - new Date(this.vm.startTimestamp).getTime() : null,
          'totalTime': null
        };
        break;
      case 'create-claim-flow-api-error':
        trackingObject = {
          'event': 'anmeld skade error',
          'virtualPath': 'opret_skade/' + this.vm.step,
          'virtualTitle': this.vm.title,
          'eventCategory': this.vm.product,
          'eventAction': this.vm.action,
          'eventLabel': this.vm.damageCodeVORefValues,
          'productId': this.vm.productId,
          'damageCode': this.vm.damageCodeVORefIds,
          'damageCodeDescription': this.vm.damageCodeVORefValuesDescription,
          'errorCode': this.vm.apiStatusCode,
          'errorMessage': this.vm.apiErrorMessage,
          'timestamp': new Date().getTime(),
          'startTimestamp': new Date(this.vm.startTimestamp).getTime(),
          'finishTimestamp': null,
          'timePassed': this.vm.startTimestamp !== 'false' ? new Date().getTime() - new Date(this.vm.startTimestamp).getTime() : null,
          'totalTime': null
        };
        break;
      case 'create-claim-flow-api-success':
        trackingObject = {
          'event': 'anmeld skade succes',
          'virtualPath': 'opret_skade/succes',
          'virtualTitle': this.vm.title,
          'eventCategory': this.vm.product,
          'eventAction': 'step_submitted',
          'eventLabel': this.vm.damageCodeVORefValues,
          'productId': this.vm.productId,
          'damageCode': this.vm.damageCodeVORefIds,
          'damageCodeDescription': this.vm.damageCodeVORefValuesDescription,
          'timestamp': new Date().getTime(),
          'startTimestamp': new Date(this.vm.startTimestamp).getTime(),
          'finishTimestamp': new Date().getTime(),
          'timePassed': this.vm.startTimestamp !== 'false' ? new Date().getTime() - new Date(this.vm.startTimestamp).getTime() : null,
          'totalTime': this.vm.startTimestamp !== 'false' ? new Date().getTime() - new Date(this.vm.startTimestamp).getTime() : null,
        };
        break;
        case 'create-claim-flow-api-failure':
          trackingObject = {
            'event': 'anmeld skade fejl',
            'virtualPath': 'opret_skade/failure',
            'virtualTitle': this.vm.title,
            'eventCategory': this.vm.product,
            'eventAction': 'step_submitted',
            'eventLabel': this.vm.damageCodeVORefValues,
            'productId': this.vm.productId,
            'damageCode': this.vm.damageCodeVORefIds,
            'damageCodeDescription': this.vm.damageCodeVORefValuesDescription,
            'timestamp': new Date().getTime(),
            'startTimestamp': new Date(this.vm.startTimestamp).getTime(),
            'finishTimestamp': new Date().getTime(),
            'timePassed': this.vm.startTimestamp !== 'false' ? new Date().getTime() - new Date(this.vm.startTimestamp).getTime() : null,
            'totalTime': this.vm.startTimestamp !== 'false' ? new Date().getTime() - new Date(this.vm.startTimestamp).getTime() : null,
        };
    }
    
    return trackingObject;
  }
}
